import { Dialog, Icon, Icons, Intent, Size } from "construct-ui";
import TreeCheckboxComponent from "./tree-checkbox.component";
import languageModel from "../../models/language.model";

/**
 * Tree Input Component
 * 
 * Input field that when clicked on will display a dialog with a tree checkbox.
 * 
 * @author Darrus Goh 
 */
export default function TreeInputComponent() {
    const TITLE_SEPARATOR = ', ';

    const STYLE_MIN_HEIGHT = '300px';
    const DEFAULT_ONCHANGE = (selectedParentCodes, selectedChildCodes) => { console.log('TreeInputComponent: onChange(selectedParentCodes, selectedChildCodes)'); }

    let isDialogOpen = false;
    let oldItemsArray = null;
    let mapName = {};

    const closeDialog = () => {
        isDialogOpen = false;
    }

    const renderLabel = (selectedItems) => {
        if (selectedItems?.length > 0) {
            if (selectedItems.length <= 3) {
                return renderTitle(selectedItems);
            } else {
                return selectedItems.length + ' ' + languageModel.getText("LT00000308", "items selected");
            }
        }

        return '';
    }

    const renderTitle = (selectedItems) => {
        return selectedItems
            .map(itemCode => mapName[itemCode])
            .join(TITLE_SEPARATOR);
    }

    const readOnly = (event) => {
        event.preventDefault();
        event.stopPropagation();
    }

    const updateMapName = (data) => {
        data.map(item => {
            if (mapName.hasOwnProperty(item.code)) {
                return;
            }
            mapName[item.code] = item.name;
            if (item.children) {
                updateMapName(item.children);
            }
        });
    }

    return {
        onupdate: ({ attrs: { items = [] } }) => {
            if (items.length > 0 && JSON.stringify(items) !== JSON.stringify(oldItemsArray)) {
                oldItemsArray = structuredClone(items);
                updateMapName(oldItemsArray);
                // Since the onupdate is after the view, the view is already rendered without the mapName object ready
                // Hence a redraw is required so that the view is rendered with the mapName object ready
                m.redraw();
            }
        },
        view: ({ attrs: {
            id = '',
            items = [],
            selectedItems = [],
            title = 'Tree Input Component',
            disabled = false,
            required = false,
            icon = Icons.LIST,
            isLevel1Expanded = false,
            onChange = DEFAULT_ONCHANGE
        } }) => {
            return [
                m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
                    class: disabled ? 'disabled' : '',
                    onclick: () => {
                        isDialogOpen = !disabled;
                    }
                },
                    m('input.flex-fill.text-start.ps-0', {
                        id,
                        disabled,
                        required,
                        type: 'text',
                        placeholder: languageModel.getText("LT00000201", "Please select"),
                        oninput: readOnly,
                        autocomplete: 'off',
                        style: {
                            width: 'inherit',
                            'overflow-x': 'hidden',
                            'text-overflow': 'ellipsis',
                            border: 'none',
                            background: 'transparent'
                        },
                        value: renderLabel(selectedItems),
                        title: renderTitle(selectedItems)
                    }),
                    m(Icon, { name: icon, intent: Intent.PRIMARY })
                ),
                m(Dialog,
                    {
                        title,
                        isOpen: isDialogOpen,
                        onClose: closeDialog,
                        content: m('.card', { style: { 'min-height': STYLE_MIN_HEIGHT }, },
                            m('.card-body',
                                m(TreeCheckboxComponent, {
                                    data: items,
                                    selectedCodes: selectedItems,
                                    isLevel1Expanded,
                                    onChange
                                })
                            )
                        ),
                        footer: m('.hstack.justify-content-end',
                            m('button.btn.btn-white', { onclick: closeDialog }, languageModel.getText('LT00000021', 'Close'))
                        )
                    }
                )
            ]
        }
    }
};